import Editor from "@monaco-editor/react";
import { useSelector } from "react-redux";
import { THEME_TYPES, THEME_COLORS } from "constants/theme";

const MONACO_THEMES = {
   DARK: "cxf-dark",
   LIGHT: "cxf-light"
};

const CxfMonacoEditor = ({ beforeMount, theme, ...rest }) => {
   const isDark = useSelector((store) => store?.portal?.settings.themeMode) === THEME_TYPES.DARK;

   const handleBeforeMount = (monaco) => {
      monaco.editor.defineTheme(MONACO_THEMES.DARK, {
         base: "vs-dark",
         inherit: true,
         rules: [],
         colors: { "editor.background": THEME_COLORS.DARK.PRIMARY_BG }
      });
      monaco.editor.defineTheme(MONACO_THEMES.LIGHT, {
         base: "vs",
         inherit: true,
         rules: [],
         colors: { "editor.background": THEME_COLORS.LIGHT.PRIMARY_BG }
      });
      beforeMount?.(monaco);
   };

   return (
      <Editor
         {...rest}
         beforeMount={handleBeforeMount}
         theme={theme || (isDark ? MONACO_THEMES.DARK : MONACO_THEMES.LIGHT)}
      />
   );
};

export default CxfMonacoEditor;
